import React from 'react';

import Layout from '../components/Layout';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
 
import a from '../assets/images/a-xx-220-art.jpg';
import b from '../assets/images/a-xx-221-art.jpg';
import c from '../assets/images/a-xx-222-art.jpg';
import d from '../assets/images/a-xx-223-art.jpg';
import e from '../assets/images/a-xx-224-art.jpg';
import f from '../assets/images/a-xx-225-art.jpg';
import g from '../assets/images/a-xx-226-art.jpg';
import h from '../assets/images/a-xx-227-art.jpg';
import i from '../assets/images/a-xx-228-art.jpg';
import j from '../assets/images/a-xx-229-art.jpg';


const pillars = [
  [
    {
      img: a,
      title:'Mango',
      text: 'Mango is called the king of fruits, equally valued in India and Hawaii. Its sweetness is sometimes used as a metaphor for spiritual bliss.'
    },
    {
      img: b,
      title:'Saffron',
      text: 'Saffron (from the Crocus sativus flower) is an orange-yellow spice highly valued by Indian chefs.'
    },
    {
      img: c,
      title:'Jasmine',
      text: 'Jasmine flowers are amazingly fragrant and thus given often as offerings to Siva.'
    },
    {
      img: d,
      title:'Prayerful Gesture',
      text: 'The anjali mudra is a gesture denoting reverence and respect. Also called pranamanjali. A gesture of greeting, in which the two palms are held gently together and slightly cupped.'
    }
  ],
  
  [
    {
      img: e,
      title:'Rig Veda',
      text: 'The Rig Veda is being scribed on a palm leaf using a metal stylus. The first and oldest of the four Veda corpora of revealed scriptures (Sruti), including a hymn collection (Samhita), priestly explanatory manuals (Brahmanas), forest treatises (Aranyakas) elaborating on the Vedic rites, and philosophical dialogs (Upanishads). Like the other Vedas, the Rig Veda was brought to Earth consciousness not all at once, but gradually, over a period of perhaps several thousand years. The oldest and core portion is the Samhita, believed to date back, in its oral form, as far as 8,000 years, and to have been written down in archaic Sanskrit some 3,000 years ago. It consists of more than 10,000 verses, averaging three or four lines (riks), forming 1,028 hymns (suktas), organized in ten books called mandalas. It embodies prayerful hymns of praise and invocation to the Divinities of nature\
      and to the One Divine.'
    },
    {
      img: f,
      title:'Sama Veda',
      text: ' Sama Veda or “Song of wisdom” is the third of the four Vedas, represented here as ola leaves on which chants are scribed. Ninety percent of its 1,875 stanzas are derived from the Rig Veda. It is a collection of hymns specially arranged and notated for chanting with a distinctive melody and cadence by the Udgata priests during yajna, fire ceremony, together with stanzas from the Yajur Veda. This Veda represents the oldest known form of Indian music.'
    },
    {
      img: g,
      title:'Yajur Veda',
      text: 'Yajur Veda, or “wisdom of sacrificial formulas,” is one of the four bodies of revelatory texts called Vedas (Rig, Sama, Yajur and Atharva). When used alone, the term Yajur Veda generally refers to this Vedas’ central and oldest portion—the Samhita, “hymn collection.”'
    },
    {
      img: h,
      title:'Atharva Veda',
      text: 'Arthava Veda, from Atharva, the name of the rishi said to have compiled this fourth Veda. It is shown here as a collection of palm-leaf books. The Atharva consists of 20 books and 720 hymns. Considered the last Veda recorded, it consists of mostly original hymns (rather than replications from the Rig Veda). In recognition of its abundant magical charms and spells, it is known as the Veda of prayer.'
    }
   ],

    [
      {
        img: i,
        title:'Mukhalinga',
        text: 'The Mukhalinga is a Sivalinga on which the face of Siva is carved.'
      },
      {
        img: j,
        title:'Kalari',
        text: 'Kalari is a form of Siva slaying the demons of the mind with His trisula.'
      },
      {
        img: '',
        title:'',
        text: ''
      },
      {
        img: '',
        title:'',
        text: ''
      }


   ]
];
 

const Pillar23 = () => (

  
  <Layout fullMenu>
    <article id="main">
      <header style={{marginBottom:0}}>
      
        <h2 style={{color:'#dd7137'}}>Pillar Twenty Three</h2>
        <p>Artwork by A. Manivelu </p>
      </header>
      

    

<section className=" style4">     
        <div  > 
 
<div style={{maxWidth:500, padding: 10,marginLeft:'auto', marginRight:'auto'}}>
<h4 style={{textAlign:'center'}}>Top</h4>
         <Carousel showArrows={false}>
                <div>
                    <img className="image" src={pillars[0][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[0][0].title}</h4>
                    <p>{pillars[0][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[0][1].title}</h4>
                    <p>{pillars[0][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[0][2].title}</h4>
                    <p>{pillars[0][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[0][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[0][3].title}</h4>
                    <p>{pillars[0][3].text}</p>
                </div>
            </Carousel> 


            <h4 style={{textAlign:'center'}}>Middle</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[1][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[1][0].title}</h4>
                    <p>{pillars[1][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[1][1].title}</h4>
                    <p>{pillars[1][1].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][2].img} />
                  <h4>SOUTH FACE:  <br/>{pillars[1][2].title}</h4>
                    <p>{pillars[1][2].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[1][3].img} />
                  <h4>WEST FACE:  <br/>{pillars[1][3].title}</h4>
                    <p>{pillars[1][3].text}</p>
                </div>
            </Carousel> 
            <h4 style={{textAlign:'center'}}>Bottom</h4>
         <Carousel showArrows={false}>
         <div>
                    <img className="image" src={pillars[2][0].img} />
                    <h4>NORTH FACE: <br/>{pillars[2][0].title}</h4>
                    <p>{pillars[2][0].text}</p>
                </div>
                <div>
                  <img className="image" src={pillars[2][1].img} />
                  <h4>EAST FACE:  <br/>{pillars[2][1].title}</h4>
                    <p>{pillars[2][1].text}</p>
                </div>
                 
            </Carousel> 

            </div>

 
      

        </div>
      </section>
      
    </article>
  </Layout>
);

export default Pillar23;
